module.exports = __webpack_public_path__ + "static/schlederer-2b80e4f6193b7b80d5737a373064f83e.jpg";